import { ClaimTypes } from '../../flows/shared/enums/ClaimTypes';
import {
  dispatchAddEmailGoBackEvent,
  dispatchAddEmailCloseEvent,
  dispatchAddEmailInvalidCodeEvent,
  dispatchAddEmailRedirectEvent,
  dispatchAddEmailResendCodeEvent,
  dispatchAddEmailValidCodeEvent,
} from './addEmailEvents';

import {
  dispatchAddPhoneGoBackEvent,
  dispatchAddPhoneCloseEvent,
  dispatchAddPhoneInvalidCodeEvent,
  dispatchAddPhoneRedirectEvent,
  dispatchAddPhoneResendCodeEvent,
  dispatchAddPhoneValidCodeEvent,
} from './addPhoneEvents';

const dispatchGoBackEvent = {
  [ClaimTypes.CELLPHONE]: dispatchAddPhoneGoBackEvent,
  [ClaimTypes.EMAIL]: dispatchAddEmailGoBackEvent,
};

const dispatchCloseEvent = {
  [ClaimTypes.CELLPHONE]: dispatchAddPhoneCloseEvent,
  [ClaimTypes.EMAIL]: dispatchAddEmailCloseEvent,
};

const dispatchResendCodeEvent = {
  [ClaimTypes.CELLPHONE]: dispatchAddPhoneResendCodeEvent,
  [ClaimTypes.EMAIL]: dispatchAddEmailResendCodeEvent,
};

const dispatchInvalidCodeEvent = {
  [ClaimTypes.CELLPHONE]: dispatchAddPhoneInvalidCodeEvent,
  [ClaimTypes.EMAIL]: dispatchAddEmailInvalidCodeEvent,
};

const dispatchValidCodeEvent = {
  [ClaimTypes.CELLPHONE]: dispatchAddPhoneValidCodeEvent,
  [ClaimTypes.EMAIL]: dispatchAddEmailValidCodeEvent,
};

const dispatchRedirectEvent = {
  [ClaimTypes.CELLPHONE]: dispatchAddPhoneRedirectEvent,
  [ClaimTypes.EMAIL]: dispatchAddEmailRedirectEvent,
};

export {
  dispatchGoBackEvent,
  dispatchCloseEvent,
  dispatchResendCodeEvent,
  dispatchInvalidCodeEvent,
  dispatchValidCodeEvent,
  dispatchRedirectEvent,
};
